import * as yup from 'yup'

const schema = yup.object().shape({
  receiverEmail: yup.string().email().required(),
})

export default schema
